import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Select from 'react-select';

import {
  DropdownIndicator,
  Option,
} from 'components/application/CollectionSelect';

export default function CollectionSelect({ defaultValue, options }) {
  const [value, setValue] = useState(
    options.find((option) => option.value === defaultValue),
  );

  return (
    <Select
      className='collection-select__select-container'
      classNamePrefix='collection-select'
      components={{ DropdownIndicator, Option }}
      id='project_configuration_project_content_review_interval'
      name='project_configuration[project_content_review_interval]'
      onChange={setValue}
      options={options}
      value={value}
    />
  );
}

CollectionSelect.propTypes = {
  defaultValue: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string }),
  ),
};
